import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ProjectOverview = () => {
  const projectStats = [
  {
    id: 1,
    icon: 'MapPin',
    value: '8',
    label: 'Thematic Trails',
    description: 'Carefully curated heritage routes'
  },
  {
    id: 2,
    icon: 'Building2',
    value: '77',
    label: 'Heritage Sites',
    description: 'Cultural and natural landmarks'
  },
  {
    id: 3,
    icon: 'Users',
    value: '12',
    label: 'Partner Organizations',
    description: 'Cross-border collaboration'
  },
  {
    id: 4,
    icon: 'Globe',
    value: '2',
    label: 'Countries',
    description: 'Serbia and Montenegro'
  }];


  return (
    <div className="bg-card rounded-lg shadow-card p-8 mb-8">
      <div className="grid lg:grid-cols-2 gap-8 items-center">
        <div>
          <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">
            Creative Twinning Project
          </h2>
          <div className="space-y-4 text-muted-foreground">
            <p className="leading-relaxed">
              The Creative Twinning initiative represents a groundbreaking cross-border tourism project 
              designed to showcase the rich cultural heritage and natural beauty of Serbia and Montenegro. 
              Through innovative digital storytelling and interactive mapping, we connect travelers with 
              authentic local experiences while preserving cultural traditions.
            </p>
            <p className="leading-relaxed">
              Our mission extends beyond traditional tourism promotion. We aim to foster sustainable 
              economic development in rural communities by highlighting local crafts, traditional 
              hospitality, and unique cultural practices that have been passed down through generations.
            </p>
            <p className="leading-relaxed">
              This EU-funded initiative brings together heritage preservation experts, tourism professionals, 
              and local communities to create immersive experiences that benefit both visitors and residents 
              while ensuring the protection of cultural and natural resources for future generations.
            </p>
          </div>
        </div>
        
        <div className="relative">
          <div className="aspect-[4/3] rounded-lg overflow-hidden shadow-md">
            <Image
              src="https://images.unsplash.com/photo-1641683933437-bf15337fece7"
              alt="Aerial view of mountainous landscape with traditional villages nestled in green valleys showcasing Balkan heritage region"
              className="w-full h-full object-cover" />

          </div>
          <div className="absolute -bottom-4 -right-4 bg-accent text-accent-foreground px-4 py-2 rounded-lg shadow-lg">
            <div className="flex items-center gap-2">
              <Icon name="Award" size={20} />
              <span className="font-medium text-sm">EU Certified Project</span>
            </div>
          </div>
        </div>
      </div>
      {/* Project Statistics */}
      <div className="mt-12 pt-8 border-t border-border">
        <h3 className="font-heading font-semibold text-lg text-foreground mb-6 text-center">
          Project Impact
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {projectStats?.map((stat) =>
          <div key={stat?.id} className="text-center">
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <Icon name={stat?.icon} size={24} className="text-primary" />
                </div>
              </div>
              <div className="text-2xl font-bold text-foreground mb-1">{stat?.value}</div>
              <div className="font-medium text-sm text-foreground mb-1">{stat?.label}</div>
              <div className="text-xs text-muted-foreground">{stat?.description}</div>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default ProjectOverview;